module.exports = __webpack_public_path__ + "static/media/YM10_3.76f3c296.jpg";